export enum Themes {
    Main = "MAIN",
    Plant = "PLANT",
    User = "USER",
    Culture = "CULTURE"
}